jQuery(document).ready(function ($) {
  
  if('.component-download-grid'){
    $grid = $('.component-download-grid');
    $grid.isotope({
      itemSelector: '.download-item',
      layoutMode: 'fitRows',
    });

    if('#filter-download'){
      $('#filter-download').change(function(){
        $filter = $('#filter-download option:selected').val();
        if($filter == 'all'){ $filter = '*'; } else { $filter = '.'+$filter; }
        $grid.isotope({
          filter: $filter
        });
      });
    }
  }

});